import useCustomMutation from "@/composables/useCustomMutation";
import { Group } from "@/interfaces/group";
import { MutationParams } from "@/interfaces/mutationParams";
import axios from "@/lib/axios";
import { useMutation, useQuery } from "@tanstack/vue-query";
import { useToast } from "vue-toastification";

interface Params {
  id: number | string;
}

interface Props {
  params: Params;
  immediate?: boolean;
}

const getGroup = async (param: Params): Promise<Group> => {
  const { data } = await axios.get<Group>(`/api/groups/${param.id}`);
  return data;
};

const deleteGroup = async (params: Params) => {
  const { data } = await axios.delete(`/api/groups/${params.id}`);
  return data;
};

const useGroup = (props: Props) => {
  const { params, immediate = true } = props || {};
  const toast = useToast();

  const {
    data: group,
    isLoading,
    refetch,
  } = useQuery(["group", params.id], () => getGroup(params), {
    enabled: immediate,
  });

  const deleteMutation = useMutation(
    (mutationParams: MutationParams<{ id: string | number }>) =>
      deleteGroup({
        id: mutationParams.params.id,
      }),
    useCustomMutation(toast, "delete"),
  );

  return {
    group,
    isLoading,
    deleteMutation: deleteMutation.mutate,
    deleteGroupAsync: deleteMutation.mutateAsync,
    refetch,
  };
};

export default useGroup;
